import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49d88e6e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=49d88e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d88e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d88e6e')) {
      api.createRecord('49d88e6e', component.options)
    } else {
      api.reload('49d88e6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49d88e6e&scoped=true&", function () {
      api.rerender('49d88e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/hotword-search/modules/addConfig/index.vue"
export default component.exports